import { render, staticRenderFns } from "./OvertimeCommentWasDeleted.vue?vue&type=template&id=bced143c"
import script from "./OvertimeCommentWasDeleted.vue?vue&type=script&lang=js"
export * from "./OvertimeCommentWasDeleted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports